import React, { useState } from "react";
import Image from "../../Assets/images/1.webp";
import Image2 from "../../Assets/images/2.webp";
import Image3 from "../../Assets/images/download.png";
import { Carousel } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

export const ProductDetail = () => {
  const images = [Image, Image2, Image3];
  const location = useLocation();
  const { product } = location.state;
  const [selectedImage, setSelectedImage] = useState(images[0]);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };
  const navigate = useNavigate();
  return (
    <div className="container panel container-fluid card wd-50  wm-100 mx-auto">
      <div className="row p-4">
        <div className="col-md-6 col-lg-12">
          <div className="d-flex justify-content-between">
            <div className="flex-1">
              <p className="category-name">{product.title}</p>
              <p className="product-price">
                قیمت:{" "}
                {product?.price?.toLocaleString("en-US", {
                  style: "decimal",
                  maximumFractionDigits: 0,
                })}
                <span className="fs-6"> تومان</span>
              </p>
            </div>
            <div className="flex-1">
              <img
                id="product-image"
                className=""
                // onClick={() => document.getElementById("fileInput").click()}
                alt="برای ارسال عکس کلیک کنید"
                src={`https://api.taab30.com${product?.pic}`}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-12 w-100">
          <div
            className="w-100"
            dangerouslySetInnerHTML={{ __html: product?.description }}
          ></div>
          <div className="text-center">
            <button
              className="btn btn-success m-2"
              onClick={() =>
                navigate("/buyproductform", { state: { product: product } })
              }
            >
              خرید
            </button>
          </div>
          {/* <div className="gallery-container">
          </div> */}
        </div>
      </div>
    </div>
  );
};

{
  /* <div className="">
  <img src={selectedImage} alt="Product" className="img-fluid" />
</div> */
}
{
  /* <div className="thumbnails mt-3">
  {images.map((image, index) => (
    <img
      key={index}
      src={image}

      alt={`Thumbnail ${index + 1}`}
      className="thumbnail w-25 p-2"
      onClick={() => handleImageClick(image)}
    />
  ))}
</div> */
}
